/**
 * Format a millisecond duration as a human-readable minute-precision string:
 *   - `0m` for zero or negative
 *   - `Nm` for under an hour
 *   - `Hh` when there are no leftover minutes
 *   - `Hh Mm` otherwise
 *
 * This is the calendar's standard duration format. It is intentionally
 * different from `TrackerDashboard/helpers.ts:formatDuration` (which renders
 * seconds for the tracker's per-row stats).
 */
export function formatDuration(ms: number): string {
  if (ms <= 0) return '0m';
  const totalMin = Math.round(ms / 60_000);
  if (totalMin < 60) return `${totalMin}m`;
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}
